import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

export const getCreditTerms = () => makeRequest(authFetch.get('/api/CreditTerms'));
export const useGetCreditTerms = () => useQuery(['creditTerms'], getCreditTerms, CacheConfig.forever);

export const getCreditTermsGrid = async (params) =>
  makeRequest(authFetch.get(`/api/CreditTerms/grid${getQueryParams(params)}`));
export const putCreditTerms = async (data) => makeRequest(authFetch.put('/api/CreditTerms', data));
export const deleteCreditTerms = async (id) => makeRequest(authFetch.delete(`/api/CreditTerms/${id}`));
export const restoreCreditTerms = async (id) => makeRequest(authFetch.patch(`/api/CreditTerms/${id}/restore`));


export const getCreditTermsAudits = async (id, params) => makeRequest(authFetch.get(`/api/CreditTerms/${id}/Audits${getQueryParams(params)}`));
export const getCreditTermsAuditProperties = async (id) => makeRequest(authFetch.get(`/api/CreditTerms/${id}/Audits/Properties`));
export const getCreditTermsAuditUsers = async (id) => makeRequest(authFetch.get(`/api/CreditTerms/${id}/Audits/Users`));